// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */

import * as React from 'react';

import {
  Action,
  EntrySectionUpdates,
  EntryType,
  GroupEventBehaviors,
  isMetricEntry,
  QueryEventEntry,
  QueryGroupedEntry,
  RowLabelType,
  SelectorTypeDefinitions,
} from 'common/query-builder/query-entry-section/types';
// eslint-disable-next-line import/no-cycle
import {QueryEntrySectionReact} from 'common/query-builder/query-entry-section';
import {TrackingEvent} from 'common/query-builder/query-entry-section/tracking';

import {BaseEntryRow} from '../base';
import type {EntryRowProps} from '../types';

/**
 * QueryGroupedEntryRow renders a grouped event row (nested events)
 */
export function GroupedEntryRow(props: EntryRowProps<QueryGroupedEntry>) {
  const onGroupLabelClick = () => {
    if (props.sectionProps.rowIndexToggleable && !isMetricEntry(props.entry)) {
      props.updateEntry(Action.Edit, {
        ...props.entry,
        entryIndexLabelToggle: !props.entry.entryIndexLabelToggle,
      });
      props.dispatchTrack(TrackingEvent.EventIndexLabelClicked, {
        ...props.getEntryTrackingProps(),
        'Previous Label': props.rowLabel,
      });
    }
  };

  const onUpdate = ({entries}: EntrySectionUpdates<QueryEventEntry>) => {
    if (isMetricEntry(props.entry)) {
      return;
    }

    if (
      entries.length === 1 &&
      props.entry.type === SelectorTypeDefinitions.GroupedEvent &&
      props.entry.event.length > 1
    ) {
      // if there is now only one entry left, ungroup it
      props.updateEntry(Action.Ungroup, entries[0]);
    } else {
      // otherwise just update the entries
      props.updateEntry(Action.Edit, {
        ...props.entry,
        type: SelectorTypeDefinitions.GroupedEvent,
        event: entries,
        filters: [],
      });
    }
  };

  return (
    <BaseEntryRow
      {...props}
      hideActions
      isPlaceholder={false}
      showLabels={false}
      renderSelector={({rowIcon}) => (
        <QueryEntrySectionReact
          elref='subEntry'
          className='sub-entry'
          containedSection
          {...props.nestedSectionParams}
          entryType={EntryType.Event}
          rowLabelPrefix={props.rowLabel}
          {...(rowIcon ? {rowLabelPrefixIcon: rowIcon} : {})}
          rowLabelType={RowLabelType.Alpha}
          rowIndex={props.index}
          rowIndexToggleable={props.sectionProps.rowIndexToggleable}
          rowIndexToggleIcon={props.sectionProps.rowIndexToggleIcon}
          rowDraggable={false}
          groupEventBehavior={GroupEventBehaviors.Append}
          trackProperties={{...(props.nestedSectionParams.trackProperties || {}), sectionName: `grouped-entry`}}
          entries={props.entry.event}
          onUpdate={onUpdate}
          onEntryGroupLabelClicked={onGroupLabelClick}
        />
      )}
      overflowControls={props.getCommonOverflowControls()}
    />
  );
}
